export const storage = {
  get: <Return>(name: string): Return | null => {
    const rawValue = window.localStorage.getItem(name)

    return !!rawValue ? JSON.parse(rawValue) as Return : null
  },
  set: (name: string, value: unknown) => {
    const jsonValue = JSON.stringify(value)

    window.localStorage.setItem(name, jsonValue)
  },
}

